/**
 * FOMO repeating countdown: same time remaining for all users (synced from epoch).
 */
function fomoTimeRemaining(cycleMs) {
  if (typeof MinimogTheme !== "undefined" && typeof MinimogTheme.fomoTimeRemaining === "function") {
    return MinimogTheme.fomoTimeRemaining(cycleMs);
  }
  const now = Date.now();
  return cycleMs - (now % cycleMs);
}

function pad2(num) {
  return num < 10 ? `0${num}` : String(num);
}

/** Read data-fomo-minutes (dataset + getAttribute for older / edge cases). */
function readFomoMinutes(el) {
  const raw = el.getAttribute("data-fomo-minutes") || el.dataset.fomoMinutes;
  if (raw == null || raw === "") return NaN;
  return parseInt(raw, 10);
}

if (!customElements.get("m-countdown-timer")) {
  class MCountdownTimer extends HTMLElement {
    connectedCallback() {
      let minutes = readFomoMinutes(this);
      if (!Number.isNaN(minutes) && minutes > 0) {
        this.startFomoCycle(minutes * 60 * 1000);
        return;
      }

      const time = this.dataset.time;
      if (!time) return;

      const endTime = Date.parse(time.split(" ").join("T"));
      if (!endTime) return;

      // Stale themes used past "end time" dates; CountdownTimer stops immediately → 00:00:00:00.
      // In the promo bar only, fall back to FOMO so the bar always shows a live countdown.
      if (endTime <= Date.now() && this.closest(".m-promotion-countdown-timer")) {
        const fallbackMin = readFomoMinutes(this);
        const m = !Number.isNaN(fallbackMin) && fallbackMin > 0 ? fallbackMin : 19;
        this.startFomoCycle(m * 60 * 1000);
        return;
      }

      new CountdownTimer(this, Date.now(), endTime);

      if (endTime > Date.now()) {
        this.classList.remove("hidden");
        this.classList.remove("m:hidden");
      }
    }

    disconnectedCallback() {
      if (this._fomoInterval) {
        clearInterval(this._fomoInterval);
        this._fomoInterval = null;
      }
    }

    startFomoCycle(cycleMs) {
      const dayEl = this.querySelector(".countdown-timer-day");
      const hourEl = this.querySelector(".countdown-timer-hour");
      const minEl = this.querySelector(".countdown-timer-minute");
      const secEl = this.querySelector(".countdown-timer-sec");

      const tick = () => {
        const remaining = fomoTimeRemaining(cycleMs);
        const DAY = 24 * 60 * 60 * 1000;
        const HOUR = 60 * 60 * 1000;
        const MIN = 60 * 1000;
        const d = Math.floor(remaining / DAY);
        const h = Math.floor((remaining % DAY) / HOUR);
        const m = Math.floor((remaining % HOUR) / MIN);
        const s = Math.floor((remaining % MIN) / 1000);

        if (dayEl) dayEl.textContent = pad2(d);
        if (hourEl) hourEl.textContent = pad2(h);
        if (minEl) minEl.textContent = pad2(m);
        if (secEl) secEl.textContent = pad2(s);
      };

      tick();
      this._fomoInterval = setInterval(tick, 1000);
      this.classList.remove("hidden");
      this.classList.remove("m:hidden");
      this.style.removeProperty("opacity");
    }
  }

  customElements.define("m-countdown-timer", MCountdownTimer);
}
